module.exports = __webpack_public_path__ + "img/characters.b6f31f64.png";